module.exports = __webpack_public_path__ + "static/media/image-card-7.e9f13f7c.png";